import { DocumentIcon } from "assets/icons";
import Chip from "components/chip/chip";
import { dateExp, dateWordShort } from "helper/helper";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableCell from "./TableCell";
import { useScrollContext } from "./ScrollableTableWrapper";
import UseContext from "hooks/useContext";
import ApiDatabase from "server";
import Button from "components/button";
import Tooltip from "components/tooltips/Tooltips";

const DownloadIcon = ({ wh, color }) => (
  <svg
    width={wh}
    height={wh}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Tbodyinvoice = ({ champsBody }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(null);
  const { hasMoved } = useScrollContext();
  const { companyData } = UseContext();
  // Récupérer l'ID depuis l'URL au chargement
  useEffect(() => {
    const idFromUrl = searchParams.get('selectedId');
    if (idFromUrl) {
      setSelectedId(idFromUrl);
      // Nettoyer l'URL après avoir récupéré l'ID
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('selectedId');
      const newUrl = newParams.toString() ? `?${newParams.toString()}` : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }, [searchParams]);

  const handleRowClick = (item) => {
    // Empêcher le clic si on vient de faire un drag
    if (hasMoved) {
      return;
    }
    
    setSelectedId(item._id);
    // Naviguer vers la page de détail de la facture avec l'ID pour le retour
    const params = new URLSearchParams({
      id: item._id,
      fileName: item.fileName,
      date: item.date_facture,
      amount: item.amount || '',
      status: item.status ? 'true' : 'false',
      returnId: item._id
    });
    navigate(`/invoice/detail?${params.toString()}`);
  };

  const handleDocumentClick = (e, item) => {
    e.stopPropagation();
    const params = new URLSearchParams({
      id: item._id,
      fileName: item.fileName,
      date: item.date_facture,
      amount: item.amount || '',
      status: item.status ? 'true' : 'false',
      returnId: item._id
    });
    navigate(`/invoice/detail?${params.toString()}`);
  };

  const handleDownloadClick = (e, item) => {
    e.stopPropagation();
    if (!localStorage.getItem('xsrfToken') || !companyData?._id || !item.fileName) return;
    ApiDatabase.postPresignFiles(
      {
        type: "invoice",
        idCompany: companyData._id,
        fileName: item.fileName,
        download: true,
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const url = urls[0]?.url || urls[0]?.uri;
        if (url) {
          window.open(url, "_blank");
        }
      },
      (err) => console.log(err)
    );
  };

  return (
    <>
      {champsBody?.slice().reverse().map((item) => {
        const isSelected = selectedId === item._id;
        return (
        <tr 
          key={item._id} 
          className={`${isSelected ? 'bg-yellow-50' : 'hover:bg-gray-50'} cursor-pointer transition-colors`}
          onClick={() => handleRowClick(item)}
        >
          {/*Mois*/}
          <td className={"uppercase py-5 pl-4 pr-2 min-w-[150px]"}>{dateExp(item.date_facture)}</td>
          {/*Montant*/}
          <td className={"py-5 px-2 min-w-[120px]"}>{item.amount ? `${item.amount} €` : ""} </td>
          {/*Etat*/}
          <td className={"py-5 px-2 min-w-[100px]"}>
            {item.status ? (
              <Chip type={"INDICATOR"} color={"INFO"}>
                Réglé
              </Chip>
            ) : (
              <Chip type={"INDICATOR"} color={"ALERT"}>
                À régler
              </Chip>
            )}
          </td>
          {/*Date*/}
          <td className={"py-5 px-2 min-w-[120px]"}>{dateWordShort(item.date_facture)}</td>
          {/*pdf*/}
          {item.status ? (
            <td
              className={"py-5 pl-2 pr-3 min-w-[100px]"}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-end items-center gap-1">
                <Tooltip text="Consulter" placement="top">
                  <span className="inline-flex">
                    <Button
                      color="TABLE"
                      size="TABLE"
                      onClick={(e) => handleDocumentClick(e, item)}
                    >
                      <DocumentIcon wh={24} color={"#111827"} />
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip text="Télécharger" placement="top">
                  <span className="inline-flex">
                    <Button
                      color="TABLE"
                      size="TABLE"
                      onClick={(e) => handleDownloadClick(e, item)}
                    >
                      <DownloadIcon wh={24} color={"#111827"} />
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </td>
          ) : (
            <TableCell
              position="last"
              hasButton
              buttonOnClick={(e) => handleDocumentClick(e, item)}
              buttonContent={<DocumentIcon wh={24} color={"#111827"} />}
              buttonTooltip="Consulter"
            />
          )}
        </tr>
        );
      })}
    </>
  );
};

export default Tbodyinvoice;
